import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {Dialog, DialogTitle, TextField} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, {useState} from "react";
import {Wheel} from "@uiw/react-color";
import {MAIN_BACKGROUND_COLOR} from "../CONSTANTS";
import ntc from "ntcjs";
import Button from "@mui/material/Button";
import {Option} from "../core/Option";
import {useSnackbar} from "notistack";

interface IProps{

    open: boolean;
    name: string;
    handleClose: () => void;
    handleDelete: () => void;

}

export default function DeleteBoardPopup(props: IProps)
{
    const { open, name, handleClose, handleDelete } = props;

    return (
        <Dialog onClose={() => handleClose()} open={open} sx={{maxWidth: 'inherit', minWidth: '400px'}}>
            <DialogTitle sx={{textAlign: 'center', fontWeight: 'bold', fontSize: '15px'}}>Remove board '{name}' ?</DialogTitle>
            <Box sx={{p:2}}>
                <Typography>Are you sure you want to remove this board? All your filled days will be gone. This action is not reversible. All traces of this board will disappear.</Typography>
            </Box>
            <Box sx={{display: 'flex', flexGrow: 1}}>

                <Button variant={'contained'} fullWidth={true} sx={{borderRadius: 0, height: '50px'}} onClick={() => handleClose()}>
                    No, don't remove
                </Button>
                <Button variant={'contained'} color={'error'} fullWidth={true} sx={{borderRadius: 0, height: '50px'}} onClick={() => handleDelete()}>
                    Yes, remove
                </Button>
            </Box>

        </Dialog>
    )

}